<div *ngFor="let item of options"><input type="checkbox" style="margin-right: 5px" [(ngModel)]="item.checked" (change)="onToggle(item)" />{{ item.label }}</div>
